import { Stack, Text } from "@certn/cascadia";
import { Illustration } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export function EmploymentVerificationComplete() {
  const { t } = useTranslation();

  return (
    <Stack gap="space-10">
      <Stack gap="space-2">
        <Text
          as="h1"
          style="form/page-title"
          testID="employment-verification-title"
        >
          {t("Employment Verification")}
        </Text>
        <Text
          style="form/body-primary"
          color="text-weak"
          testID="employment-verification-subtitle"
        >
          {t(
            "Your verification details have been submitted. Please continue to the next step."
          )}
        </Text>
      </Stack>
      <Stack align="center">
        <Illustration name="verification-success" size={132} />
      </Stack>
    </Stack>
  );
}
